<template>
  <ul class="list">
    <li
      v-for="category in withChildrenCategories"
      :key="category.id"
      class="list__item item"
    >
      <label class="label">
        <input
          type="checkbox"
          :checked="isSelected(category.id)"
          class="label__input"
          @input="$emit('toggle-select', category.id)"
        />
        <p
          class="label__name category"
          :class="{ 'category--selected': isSelected(category.id) }"
        >
          {{ category.name }}
        </p>
      </label>
      <TagFinderCategoryList
        v-if="category.children.length > 0"
        :selectedTaxonomyIds="selectedTaxonomyIds"
        :categories="category.children"
        :allCategories="allCategories"
        class="item__children"
        @toggle-select="$emit('toggle-select', $event)"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TagFinderCategoryList',
  props: {
    selectedTaxonomyIds: {
      type: Array,
      default: () => [],
    },
    // その階層だけのカテゴリの配列
    categories: {
      type: Array,
      default: () => [],
    },
    // 全体のカテゴリの配列
    allCategories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    withChildrenCategories() {
      return this.categories.map((cateogory) => {
        return {
          ...cateogory,
          children: this.allCategories.filter(
            (childCategory) => childCategory.parent_id === cateogory.id
          ),
        };
      });
    },
  },
  methods: {
    isSelected(categoryId) {
      return this.selectedTaxonomyIds.includes(categoryId);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  font-size: 12px;

  &__item {
    line-height: 16px;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.item {
  &__children {
    margin-left: 24px;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.label {
  &__input {
    display: none;
  }
}

.category {
  display: inline-block;
  padding: 4px 6px;
  background-color: #eee;
  color: #333;
  border: 1px solid transparent;
  border-radius: 4px;
  transition: filter 200ms;

  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }

  &--selected {
    background: #fff7ad;
    border: 1px solid #e8e800;
  }
}
</style>
